export default __webpack_public_path__ + "static/media/vtcmarketingbanner.bf93ebfa.png";